"use client";
import { cva as t } from "class-variance-authority";
import { button as a } from "./button.js";
import { cn as r } from "../../utils.js";
const i = t("", {
  variants: {
    slot: {
      root: [
        "bg-gray-50 dark:bg-transparent",
        "border border-transparent dark:border-gray-dark-700",
        "rounded-md p-0.5 flex items-center"
      ],
      button: [
        r(
          a({ size: "xs" }),
          "group",
          "rounded data-[active]:shadow",
          "bg-transparent data-[active]:bg-white",
          "text-gray-600 data-[active]:text-gray-800",
          "dark:text-white-alpha-600 dark:data-[active]:text-white-alpha-950",
          "dark:data-[active]:bg-gray-dark-700 dark:shadow-none",
          "hover:text-gray-800 hover:dark:text-white-alpha-950",
          "focus-visible:ring-transparent"
        )
      ],
      icon: [
        "mr-1 text-gray-500 data-[active]:text-gray-600",
        "dark:text-white-alpha-500 dark:data-[active]:text-white-alpha-600",
        "group-hover:text-gray-600 dark:group-hover:text-white-alpha-600"
      ]
    }
  }
});
export {
  i as widgetToggle
};
